/**
 * 객관식 정답 칸 값 → 선지 번호(F15, BE-20260925 §3).
 *
 * 검수 창의 선지 버튼은 정답이 원문자(「③」)와 똑같을 때만 켜졌다. 그런데 정답지 OCR·옛 AI 분석은 「3」·「(3)」·「3번」을
 * 남겨 버튼이 모두 꺼진 채였고, 값 3 이 「③ 선지」인지 「값이 3 인 선지」인지 화면이 말해 주지 않았다.
 * 이제 그런 값도 선지 번호로 읽어 버튼을 켜고, 그 선지의 내용을 옆에 보인다(혼동 방지).
 *
 * 하나만 읽는다 — 「①, ⑤」 같은 복수 정답·범위 밖 번호·그 밖의 글은 null(버튼을 켜지 않는다).
 * 서버는 2026-09-25(B16)부터 AI 객관식 답을 원문자로 저장하므로, 새 데이터는 대개 원문자로 온다.
 */
const CIRCLED = ['①', '②', '③', '④', '⑤', '⑥', '⑦', '⑧', '⑨', '⑩'];

export function choiceNoOfAnswer(text, maxNo = 10) {
  const t = String(text ?? '').trim();
  if (!t) return null;
  const ci = CIRCLED.indexOf(t);
  if (ci >= 0) return ci + 1 <= maxNo ? ci + 1 : null;
  const m = t.match(/^\(\s*(\d{1,2})\s*\)$|^(\d{1,2})\s*번?$/);
  if (!m) return null;
  const n = Number(m[1] ?? m[2]);
  return n >= 1 && n <= maxNo ? n : null;
}

/** 정답 칸 값이 원문자가 아닌데 선지로 읽혔는가 — 버튼 설명이 「③ 으로 읽었다」를 말할지 정한다 */
export function isLooseChoiceAnswer(text, maxNo = 10) {
  const t = String(text ?? '').trim();
  return choiceNoOfAnswer(t, maxNo) != null && !CIRCLED.includes(t);
}
